import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-secondary-50">
                SP完全指南
              </span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              致力于传播科学、安全、理性的SP知识，帮助每一位读者在知情、自愿、安全的前提下获取正确信息。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-secondary-50 mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-secondary-100 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-secondary-100 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/sp-beginner" className="text-sm text-secondary-300 hover:text-secondary-100 transition-colors">
                  SP新手指南
                </Link>
              </li>
              <li>
                <Link to="/category/sp-safety" className="text-sm text-secondary-300 hover:text-secondary-100 transition-colors">
                  SP安全须知
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-secondary-50 mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-secondary-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-secondary-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2.5 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@sp-guide.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-base"></i>
                <span>安全 · 知情 · 自愿</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-secondary-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} SP完全指南. 本站内容仅供成人知识科普，请理性阅读。
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <span>安全第一</span>
            <span className="w-1 h-1 rounded-full bg-secondary-500"></span>
            <span>知情同意</span>
            <span className="w-1 h-1 rounded-full bg-secondary-500"></span>
            <span>自愿参与</span>
          </div>
        </div>
      </div>
    </footer>
  );
}